import React from "react";
import ProductComingSoonLanding from "./ProductComingSoonLanding.jsx";

const HERO_TAGS = ["Mixed use", "Retail + residential", "Split titles"];

const FEATURE_CARDS = [
  {
    title: "Mixed-use modelling",
    description:
      "Represent how commercial and residential parts contribute value, income, and security for semi-commercial cases.",
  },
  {
    title: "Lender appetite by split",
    description:
      "Match lenders comfortable with shop-with-flat, pub-with-lettings, and other combined-use layouts.",
  },
  {
    title: "Shortlist & apply in one journey",
    description:
      "When live, compare semi-commercial products and continue through application without leaving Dynesourcer.",
  },
];

const STEPS = [
  {
    title: "Define the mixed-use split",
    body: "Floor areas, income streams, and use classes show lenders how the property functions day to day.",
  },
  {
    title: "Compare semi-commercial options",
    body: "See indicative pricing that respects both the trading element and any residential tenancy.",
  },
  {
    title: "Shortlist and apply",
    body: "Pick semi-commercial lenders to follow up with once sourcing and calculator tools are live.",
  },
];

const CRITERIA_CHIPS = [
  "% commercial vs residential (by value or income)",
  "Use class & planning",
  "Separate / combined titles",
  "Rental income breakdown",
  "Loan amount & LTV",
  "Trading business on site",
  "Tenant mix",
  "Property condition & works",
  "Valuation approach (investment vs hybrid)",
];

export default function SemiCommercialCalculator() {
  return (
    <ProductComingSoonLanding
      productLabel="Semi-commercial"
      heroTitle="Semi-Commercial Calculator"
      heroDescription="Finance for properties that blend commercial and residential use. Coming soon."
      heroSrc="/Semi-commerical.webp"
      primaryCtaText="Source semi-commercial (Coming soon)"
      heroTags={HERO_TAGS}
      introTitle="Semi-commercial calculator (Coming soon)"
      introBody="Semi-commercial cases need clarity on how each part of the building is used and valued. Dynesourcer will surface lenders who specialise in mixed-use security while we finish the calculator."
      featureCards={FEATURE_CARDS}
      howItWorksTitle="How semi-commercial will work on Dynesourcer"
      howItWorksIntro="Borrowers map commercial and residential elements; we align with lenders whose mixed-use mandates fit."
      steps={STEPS}
      criteriaTitle="Typical semi-commercial criteria (preview)"
      criteriaIntro="Underwriters look at split of income, use class, and title structure. Preview filters below."
      criteriaChips={CRITERIA_CHIPS}
      ctaTitle="Financing a mixed-use building?"
      ctaDescription="Follow the borrower journey to see how sourcing and applications come together. Semi-commercial tools arrive here next."
      ctaPrimary={{ to: "/explore-borrower-journey", label: "Explore borrower journey" }}
      ctaSecondary={{ to: "/commercial-calculator-uk", label: "Commercial calculator preview" }}
    />
  );
}
